<template>
    <div>
        <app-header title="Januar 2018" :back="'true'" :back_path="'konto'"></app-header>
        <div class="page">
            <div class="table-title">
                <img src="../../assets/images/mein_konto_icon.png">
                <span>
                    Transaktionen Verlauf
                </span>
            </div>
            <table class="transaktioren">
                <tr>
                    <td>
                        <h3>Spotify</h3>
                        <h4>Jan 2018</h4>
                    </td>
                    <td>
                        <h3>+ CHF 254.20</h3>
                        <span class="green">Gutschrift</span>
                    </td>
                </tr>
                <tr>
                    <td>
                        <h3>Apple Music</h3>
                        <h4>Feb 2018</h4>
                    </td>
                    <td>
                        <h3>-CHF 128.70</h3>
                        <span class="green">Gutschrift</span>
                    </td>
                </tr>
                <tr>
                    <td>
                        <h3>Google Play</h3>
                        <h4>Jan 2018 - Feb 2018</h4>
                    </td>
                    <td>
                        <h3>+ CHF 116.10</h3>
                        <span  class="green">Gutschrift</span>
                    </td>
                </tr>
                <tr>
                    <td>
                        <h3>Deezer</h3>
                        <h4>Feb 2018</h4>
                    </td>
                    <td>
                        <h3>+ CHF 104.90</h3>
                        <span  class="green">Gutschrift</span>
                    </td>
                </tr>
            </table>


        </div>

    </div>
</template>

<script>
    import Header from '../Header';
    import Footer from '../Footer_menu'

    export default {
        computed: {
            items() {
                return this.$store.getters.Meine_trends;
            }
        },
        components: {
            appHeader: Header,
            appFooter: Footer
        }
    }
</script>

<style lang="scss" scoped>
    @import '../../assets/css/style';

    .page {
        padding-top: 60px;
        color: #252226;
        overflow: hidden;


        .table-title{
            margin-top:20px;
            margin-left:20px;
            span{
                font-size:1.1rem;
                letter-spacing: -0,24px;
                color: #252226;
                margin-left:7px;
            }
        }
        table.transaktioren{
            border-left:2px $lila solid;
            margin-left:25px;
            margin-top:12px;
            td{
                &:nth-of-type(1){
                    width: 71%;
                    padding:15px 0 10px 22px;
                }
                &:nth-of-type(2){
                    padding-top:10px;

                    text-align: right;
                }
                h3{
                    font-size: 1.4rem;
                    letter-spacing: -0,24px;
                    font-weight: 600;
                    margin-bottom:1px;
                }
                h4{
                    color: $font-color_dark;
                    font-weight: 300;
                    font-size: 1.2rem;
                    margin-top:5px;
                }
                span{
                    font-size: 1.2rem;
                    display: block;
                    &.green{
                        color: $success;
                    }
                    &.red{
                        color: $warning;
                    }
                }
            }
        }



    }






</style>



// WEBPACK FOOTER //
// src/components/konto/Konto_detail.vue